import { Spacings } from '../styleConstants';

const boxShadowGenerator = ({
  xOffset = Spacings.SPACING_0B,
  yOffset = Spacings.SPACING_4B,
  blur = Spacings.SPACING_8B,
  spread = Spacings.SPACING_0B,
  color = '',
  theme
}) => {
  const shadowColor = color || theme?.colors.dropShadowV5 || 'none';
  return `${xOffset} ${yOffset} ${blur} ${spread} ${shadowColor}`;
};

export default boxShadowGenerator;
